import React, { createContext, useContext, useState, useCallback } from 'react';

const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
    const [alert, setAlert] = useState({
        show: false,
        message: '',
        type: 'info', // 'success', 'error', 'info', 'warning'
    });

    const showAlert = useCallback((message, type = 'info', duration = 3000) => {
        setAlert({
            show: true,
            message,
            type,
        });

        if (duration > 0) {
            setTimeout(() => {
                setAlert((prev) => ({ ...prev, show: false }));
            }, duration);
        }
    }, []);

    const hideAlert = useCallback(() => {
        setAlert((prev) => ({ ...prev, show: false }));
    }, []);

    return (
        <AlertContext.Provider value={{ alert, showAlert, hideAlert }}>
            {children}
        </AlertContext.Provider>
    );
};

export const useAlert = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useAlert must be used within an AlertProvider');
    }
    return context;
};
